import { useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import TypeDestinationForm from 'system/components/type-destination/form';
import { typeDestinationCrumbs } from '../constants';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeDestination } from 'shell/models/type-destination';
import {
  transformTypeDestination,
  transformTypeDestinationResponse,
} from '../utils/transformer-type-destination';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformRequestTypeDestination } from '../utils/transformer-type-destination-request';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';

const TypeDestinationEditPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipidestinazione');
  };

  const params = useParams();

  const [typeDestination] = useHttpFetch<
    HttpResponse<TypeDestination>,
    transformTypeDestinationResponse
  >(`${__OPERATION__EVENT__ADMIN__}/tipoDestinazione/${params.id}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformTypeDestination,
  });

  const updateTypeDestination = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/tipoDestinazione`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback((formValues) => {
    const data = transformRequestTypeDestination(formValues);
    (
      updateTypeDestination({
        data,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/tipidestinazione');
    });
  }, []);

  return (
    <>
      <Breadcrumbs items={[...typeDestinationCrumbs, { name: 'Modifica Tipo/Destinazione' }]} />
      <TypeDestinationForm
        forminitialValues={typeDestination?.data as transformTypeDestinationResponse}
        onOk={onSubmit}
        title="Modifica"
        onCancel={onCancel}
        isEdit
      />
    </>
  );
};
TypeDestinationEditPage.displayName = 'Edit single event  type page';
export default TypeDestinationEditPage;
